module.exports = __webpack_public_path__ + "static/media/delete.83b0d90a.svg";